import React from 'react';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';

function EntityHeader({ page, onAdd, entityName, entityOptions, themeKey, onPageToggle }) {
  // featuring for style guide header updates
  const production = window.zola.env === 'production';
  return (
    <div className={`cms-edit-header row ${page.type.toLowerCase()}-edit-header`}>
      <div className="col-xs-8">
        <h3 className={!production ? 'page-header-v2' : ''}>
          {page.menu_title}
          {page.type !== 'HOME' && (
            <div className="pull-right">
              <div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Control if guests see this page. Set to &quot;Hidden&quot; if you don't want to use it or it's still a work in progress. Set to &quot;Visible&quot; if you're ready to share.">
                <Toggle
                  checked={!page.hidden}
                  onChange={() => onPageToggle(page.id)}
                  icons={{ checked: <span className="toggle-label checked">Visible</span>, unchecked: <span className="toggle-label unchecked">Hidden</span> }}
                />
              </div>
            </div>
          )}
        </h3>
        <p>{page.intro_copy}</p>
        {page && page.type && themeKey && (
          <a href={`/wedding/sample-${themeKey}/${page.type === 'HOME' ? '' : page.type.toLowerCase()}`} target="_blank" rel="noopener noreferrer" className="margin-top text-button">See demo page &rsaquo;</a>
        )}
        <br />
        {entityName && (
          <button className="btn btn-primary margin-top margin-bottom" onClick={onAdd}>+ Add {entityName}</button>
        )}
        {entityOptions && entityOptions}
      </div>
      <div className="col-xs-4">
        <img src={`/images/pages/${page.type.toLowerCase()}.png`} alt={page.menu_title} className="margin-top-2x center-block" srcSet={`/images/pages/${page.type.toLowerCase()}.png 1x, /images/pages/${page.type.toLowerCase()}@2x.png 2x`} width="110" height="110" />
      </div>
    </div>
  );
}


EntityHeader.propTypes = {
  page: PropTypes.shape({}).isRequired,
  onAdd: PropTypes.func,
  entityName: PropTypes.string,
  entityOptions: PropTypes.element,
  themeKey: PropTypes.string,
  onPageToggle: PropTypes.func,
};

export default EntityHeader;



/** WEBPACK FOOTER **
 ** ./src/components/manage/website/entities/EntityHeader.jsx
 **/